import React, {useEffect, useState} from 'react';
import axios, {AxiosResponse} from 'axios';
import {useMeetingAppDispatch, useMeetingAppState} from './eventSlotSelectionApp.store';
import DayTimeSelector from './dayTimeSelector/dayTimeSelector';
import {CalendarEventData} from '../../generated/dto';
import {MeetingAppProps} from './index';
import {getYearMonthInExchangeFormat} from '../shared/functions.pure';

const EventSlotSelectionApp: React.FC<MeetingAppProps> = ({
  eventId,
  orderEntryId,
  adminOrderId,
  nextOccurrence
}) => {
  const meetingDispatch = useMeetingAppDispatch();
  const {displayedMonth} = useMeetingAppState();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    axios
      .get(`${nautilusApi.root}nautilus/v1/services/${eventId}`, {
        headers: {'X-WP-Nonce': nautilusApi.nonce},
        params: {yearMonth: getYearMonthInExchangeFormat(displayedMonth ?? nextOccurrence)},
        cancelToken: source.token
      })
      .then((response: AxiosResponse<CalendarEventData>) => {
        const {data} = response;

        meetingDispatch({
          type: 'LOAD_DATA',
          payload: {
            meeting: data,
            order_entry_id: orderEntryId,
            adminOrderId: adminOrderId
          }
        });
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      source.cancel('changed month');
    };
  }, [displayedMonth]);

  return (
    <>
      <div className={'row g-0 ' + (isLoading ? 'is-loading' : '')}>
        <div className={'col'}>
          <div className={'position-sticky meeting-date-time'}>
            <div className={'row'}>
              <div className={'col-12 position-relative'}>
                <DayTimeSelector startDate={nextOccurrence} />

                {isLoading && (
                  <div
                    className="spinner spinner-border spinner-border-sm text-primary"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventSlotSelectionApp;
